import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  GROUPS, OPEN_CHATS, SET_ACTIVITY_MESSAGES, SET_ACTIVITY_MESSAGES_REMINDERS, SET_ACTIVITY_MESSAGES_LAST_FETCHED,
  OPEN_PROJECTS
} from "../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import { Scrollbars } from "react-custom-scrollbars";
import "../../styles/pages.css";
import { $crud } from "../../helper/CrudFactory";
import { BASE_URL, KJUUP_COLORS } from "../../helper/constants";
import LanguageContext from "../../helper/LanguageContext";
import _ from "lodash";
import AddProjectUser from "./AddProjectUser";
import AddProjectChatUser from "./AddProjectChatUser";
import "./UserInfo.css";
import { Modal } from "react-bootstrap";
import LeaveConfirmDialog from "../../components/LeaveConfirmDialog";
import Cropper from "react-easy-crop";
import { stripMarkdown } from "../../utils/conversationUtils";
import { getRoomPeople, invalidateRoomPeople, roleLineOf } from "../../utils/roomPeople";
import {
  InfoAvatar,
  InfoAwayBanner,
  InfoCaption,
  InfoCard,
  InfoEditBox,
  InfoEditPencil,
  InfoHero,
  InfoLeaveButton,
  InfoMemberRow,
  InfoPopoverMenu,
  InfoRow,
  InfoTiles,
  InfoToggleRow,
  fillN,
  infoText,
  infoToneClass,
  myFullName,
  positionFormatter,
  useChatMediaCount,
} from "../../components/chat/info/ChatInfoParts";
import InfoExportCard from "../../components/chat/info/InfoExportCard";
import { lastOnlineText } from "../../utils/lastOnline";
import { isTeamsGuest } from "../../utils/teams/combinedChat";

// Mobile GroupInfo: the description shows its first 120 characters with "...mehr".
const DESCRIPTION_PREVIEW = 120;

const avatarSrc = (path) => {
  if (!path) return "";
  return /^(https?:|blob:|data:)/.test(String(path)) ? path : BASE_URL + path;
};

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    overflowX: "hidden",
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function UserInfo(props) {
  const dispatch = useDispatch()
  const history = useHistory()
  const user = useSelector((state) => state.user);
  const activityMessages = useSelector((state) => state.activityMessages);
  const activityMessagesReminders = useSelector((state) => state.activityMessagesReminders);
  const [loaded, setLoaded] = useState(false);
  const [admin, setAdmin] = useState({});
  const [addMember, setAddMember] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [users, setUsers] = useState([]);
  const { isGerm, strings, language } = React.useContext(LanguageContext);
  const [allUsers, setAllUsers] = useState(props.users ? props.users : []);
  const [isEditing, setIsEditing] = useState(false);
  const [description, setDescription] = useState(null);
  const [editedDescription, setEditedDescription] = useState('');
  const [editedName, setEditedName] = useState('');
  const [showFullDescription, setShowFullDescription] = useState(false);
  const textareaRef = useRef(null);
  const [groupName, setGroupName] = useState(props.chat?.name);
  const [isEditingName, setIsEditingName] = useState(false);
  const [deeplink, setDeepLink] = useState("");
  const userN = useSelector((state) => state.user);
  const [isAutomaticExportOn, setIsAutomaticExportOn] = useState(false);
  const [exportEmail, setExportEmail] = useState("");
  const [originalExportEmail, setOriginalExportEmail] = useState("");
  const [showConfirmButton, setShowConfirmButton] = useState(false);
  const [showChatHistoryRequest, setShowChatHistoryRequest] = useState(false);
  const [showLeaveConfirmDialog, setShowLeaveConfirmDialog] = useState(false);
  const [chatHistoryEmail, setChatHistoryEmail] = useState('');
  const [viewLoader, setViewLoader] = useState(false);
  const [isLoadingChatHistory, setIsLoadingChatHistory] = useState(false);
  const toggleSwitchRef = useRef(null);
  const [groupAvatar, setGroupAvatar] = useState(null);
  const [groupAvatarPreview, setGroupAvatarPreview] = useState(null);
  const [isUploadingAvatar, setIsUploadingAvatar] = useState(false);
  const fileInputRef = useRef(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [originalFileName, setOriginalFileName] = useState('');
  const [isMuted, setIsMuted] = useState(false);
  const [showMuteConfirm, setShowMuteConfirm] = useState(false);
  const [showExportInfo, setShowExportInfo] = useState(false);
  const [showEmailInfo, setShowEmailInfo] = useState(false);
  const [unavailableMembers, setUnavailableMembers] = useState(props.unavailableMembers || []);
  // Export tile: scrolls to the export card and opens the PDF export (counter).
  const [exportSignal, setExportSignal] = useState(0);
  const exportCardRef = useRef(null);
  // Member row menu: { member, anchorEl }.
  const [memberMenu, setMemberMenu] = useState(null);
  // The room's member list (GET /building/:id/user): "role · company" and External.
  const [roomPeople, setRoomPeople] = useState(null);
  const mediaCount = useChatMediaCount(props.chat?.id, !!props.viewByOwner);
  const roomId = props.project?.id;

  useEffect(() => {
    if (!roomId) return undefined;
    let live = true;
    getRoomPeople(roomId).then((res) => {
      if (live && res) setRoomPeople(res);
    });
    return () => {
      live = false;
    };
  }, [roomId]);

  const handleEditClick = () => {
    setIsEditing(true);
    setEditedDescription(description);
  };

  const handleEditClickName = () => {
    setIsEditingName(true);
    setEditedName(groupName);
  };

  useEffect(() => {
    setIsEmailOn(userN?.emailNotification && userN?.emailVerified)
  }, [userN])

  // Automatically generate invite link when component loads
  useEffect(() => {
    if (props.chat?.id && props.project?.id && !props.isInternal && !props.viewByOwner && !deeplink) {
      getInviteLink();
    }
  }, [props.chat?.id, props.project?.id, props.isInternal, props.viewByOwner])

  const handleSave = async () => {
    setDescription(editedDescription);
    setIsEditing(false);
    const { data } = await callAPI(`/group/changeGroupDescription`, {}, "POST", {
      id: props.chat?.id,
      description: editedDescription
    });
    if (data.status) {
      // await $crud.notify({
      //   type: "success",
      //   message: data.message,
      // });
    }
    else {
      await $crud.notify({
        type: "error",
        message: data.message,
      });
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setIsEditingName(false)
    setEditedDescription('');
  };

  const handleInputChange = (e) => {
    setEditedDescription(e.target.value);
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [description]);

  const [addUserAction, setAddUserAction] = useState({
    status: false,
    id: props.project.id,
    isInternal: props.project.isInternal,
    cID: props.project.cID
  });
  const [addChatUserAction, setAddChatUserAction] = useState({
    status: false,
    id: props.project.id,
    isInternal: props.project.isInternal,
    cID: props.project.cID
  });
  const getDetails = async () => {
    const id = props.chat?.id;
    const { data } = await callAPI(`/group/${id}/info`, {}, "GET");
    if (data?.status) {
      const isExist = await data?.groupInfo?.users?.find((u) => u.id === user?.id);
      setDescription(data.groupInfo.description)
      setIsEmailOn(data.groupInfo.emailNotification);
      // Set group avatar if exists
      if (data.groupInfo.avatar) {
        setGroupAvatar(data.groupInfo.avatar);
        setGroupAvatarPreview(BASE_URL + data.groupInfo.avatar);
      }
      // Set automatic export settings from groupInfo (check both isChatExport and automaticExport)
      const exportEnabled = data.groupInfo.isChatExport !== undefined
        ? data.groupInfo.isChatExport
        : (data.groupInfo.automaticExport !== undefined ? data.groupInfo.automaticExport : false);
      setIsAutomaticExportOn(exportEnabled);
      // Set export email from groupInfo
      if (data.groupInfo.exportEmail) {
        setExportEmail(data.groupInfo.exportEmail);
        setOriginalExportEmail(data.groupInfo.exportEmail);
      } else if (userN?.email) {
        setExportEmail(userN.email);
        // Don't set originalExportEmail here - it hasn't been saved to group settings yet
        // This will make the Update button visible so user can save it
        setOriginalExportEmail("");
      }
      if (isExist) {
        setIsMember(isExist.isLeave)
        setIsAdmin(isExist.isAdmin);
        setIsMuted(!!isExist.isMute);
        setUsers(data?.groupInfo?.users);
      }
      else if (props.viewByOwner) {
        setUsers(data?.groupInfo?.users);
      }
      setUnavailableMembers(Array.isArray(data.groupInfo.unavailableMembers) ? data.groupInfo.unavailableMembers : []);
      const adminDetails = await data?.groupInfo?.users?.find(
        (user) => user.isAdmin
      );
      setAdmin(adminDetails);
      setLoaded(true);
    }
  };

  console.log("props", users);

  const toggleBlockUser = () => {
    setShowLeaveConfirmDialog(true);
  };

  const handleLeaveConfirm = async () => {
    setShowLeaveConfirmDialog(false);
    const id = props.chat?.id;
    const userId = user?.id;
    const { data } = await callAPI(`/group/${id}/leave`, {}, "DELETE", {
      id: id,
      user: userId,
    });
    dispatch({ type: SET_ACTIVITY_MESSAGES_LAST_FETCHED, payload: 0 });
    props.hideGroup({ isLeave: true });
    if (props.getChats) {
      props.getChats();
    }
    props.handleClose();
  };
  const viewSearch = () => {
    if (typeof props.setSearch !== "function") return;
    props.setSearch();
    props.handleClose();
  };

  // Export tile: open the PDF export in the export card and scroll it into view.
  const goExport = () => {
    setExportSignal((n) => n + 1);
    setTimeout(() => {
      if (exportCardRef.current) exportCardRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  };

  const openReplacementChat = async (member) => {
    try {
      const { data } = await callAPI('/group', {}, 'POST', {
        groupType: 'user', isOneToOne: true, users: [user?.id, member.replacementUserId],
      });
      if (data?.chat?.id) {
        if (props.handleClose) props.handleClose();
        const chatPayload = { ...data.chat, isOpened: true, key: data.chat.id };
        dispatch({ type: OPEN_CHATS, openChats: [chatPayload] });
        dispatch({ type: OPEN_PROJECTS, openProjects: [] });
        history.push('/messages');
      }
    } catch (err) { console.error('Failed to open replacement DM:', err); }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const projectCompanyId = () =>
    props.project?.cID || props.project?.companyId || props.project?.company_id || props.project?.company;

  const handleAddUser = () => {
    // A group chat inside the project (not the project's own "All" chat): pick from the people
    // not yet in this group — project members included — and add them to the group
    // (GET /group/:id/invitable-users + PUT /group/:id/add; people from outside the project join
    // the project first). The project picker (getMyBuildingContacts + /building/:id/add) only
    // lists people outside the project and adds them to the project, never to this group.
    if (props.chat?.id && !props.chat?.defaultChatGroup) {
      setAddChatUserAction({
        status: true,
        id: props.project.id,
        groupMode: true,
        isInternal: props.project.isInternal,
        cID: projectCompanyId(),
      });
      return;
    }
    setAddUserAction({
      status: true,
      id: props.project.id,
      addAsMember: true,
      isInternal: props.project.isInternal,
      cID: props.project.cID
    });
  };

  // Back from the add-member panels: reload the members and the room's people.
  const addPanelOpen = !!(addUserAction.status || addChatUserAction.status);
  const addPanelWasOpen = useRef(false);
  useEffect(() => {
    if (addPanelOpen) {
      addPanelWasOpen.current = true;
      return;
    }
    if (!addPanelWasOpen.current) return;
    addPanelWasOpen.current = false;
    invalidateRoomPeople(roomId);
    getRoomPeople(roomId).then((res) => {
      if (res) setRoomPeople(res);
    });
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addPanelOpen]);

  const removeMember = async (actionUser) => {
    try {
      await $crud.confirm({
        title: "",
        textContent: isGerm ? "Wollen Sie den/die Teilnehmer/in wirklich aus der Chat Gruppe entfernen?" : "You want to remove this user from group?",
        options: {
          ok: strings.ok,
          cancel: strings.cancel,
        },
      });
    } catch (e) {
      return;
    }
    const { data } = await callAPI(
      `/group/${props.chat?.id}/remove`,
      {
        user: actionUser?.id,
      },
      "DELETE"
    );
    if (data.status) {
      getDetails();
    }
  };

  const canManageAdmins =
    isAdmin &&
    !props.project?.viewByOwner &&
    !props.fromActivity &&
    !props.project?.isDone &&
    !props.chat?.isOneToOne;

  const toggleGroupAdmin = async (actionUser) => {
    if (!actionUser?.id || actionUser.id === user?.id) return;
    const assigning = !actionUser.isAdmin;
    try {
      await $crud.confirm({
        title: "",
        textContent: assigning ? strings.add_member_admin_right : strings.remove_member_admin_right,
        options: {
          ok: strings.confirm || strings.ok,
          cancel: strings.cancel,
        },
      });
    } catch (e) {
      return;
    }
    const { data } = await callAPI(
      `/group/${props.chat?.id}/admin/${actionUser.id}`,
      {},
      assigning ? "PUT" : "DELETE"
    );
    if (data?.status) {
      getDetails();
    } else {
      await $crud.notify({
        type: "error",
        message: data?.message,
      });
    }
  };

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };


  const displayDescription = () => {
    if (!description) return !isGerm ? "Add description..." : "Beschreibung hinzufügen...";
    if (showFullDescription) return description;
    if (description.length > DESCRIPTION_PREVIEW) return `${description.slice(0, DESCRIPTION_PREVIEW)}`;
    return description;
  };


  const handleSaveGroupname = async () => {
    if (editedName) {
      setGroupName(editedName);
      setIsEditingName(false);
      const { data } = await callAPI(`/group/changeGroupName`, {}, "POST", {
        id: props.chat?.id,
        name: editedName
      });
      if (data.status) {
        const groupId = props.chat?.id;

        // Update groups in Redux
        if (props.groups) {
          const updatedGroups = props.groups.map((g) =>
            g.id === groupId ? { ...g, name: editedName } : g
          );
          props.updateGroups(updatedGroups);
        }

        // Update open chats in Redux
        if (props.openChats) {
          const updatedOpenChats = props.openChats.map((c) =>
            c.id === groupId ? { ...c, name: editedName } : c
          );
          props.updateOpenChatsList(updatedOpenChats);
        }

        // Update activity messages (LatestMessages chat list) in Redux
        if (activityMessages) {
          const updatedMessages = activityMessages.map((m) =>
            m.group?.id === groupId
              ? { ...m, name: editedName, group: { ...m.group, name: editedName } }
              : m
          );
          dispatch({ type: SET_ACTIVITY_MESSAGES, messages: updatedMessages });
        }

        // Update activity messages reminders in Redux
        if (activityMessagesReminders) {
          const updatedReminders = activityMessagesReminders.map((m) =>
            m.group?.id === groupId
              ? { ...m, name: editedName, group: { ...m.group, name: editedName } }
              : m
          );
          dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: updatedReminders });
        }
      }
      else {
        await $crud.notify({
          type: "error",
          message: data.message,
        });
      }
    }
    else {
      await $crud.notify({
        type: "error",
        message: !isGerm ? "Add group name" : "Gruppennamen hinzufügen",
      });
    }
  };

  const handleInputChangeNAme = (e) => {
    setEditedName(e.target.value);
  };

  const handleAvatarClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check if file is an image
    if (!file.type.startsWith('image/')) {
      await $crud.notify({
        type: "error",
        message: isGerm ? "Bitte wählen Sie eine Bilddatei aus" : "Please select an image file",
      });
      return;
    }

    // Check file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      await $crud.notify({
        type: "error",
        message: isGerm ? "Bild darf nicht größer als 10MB sein" : "Image must not exceed 10MB",
      });
      return;
    }

    // Store original filename
    setOriginalFileName(file.name);

    // Create image URL for cropping
    const imageUrl = URL.createObjectURL(file);
    setImageToCrop(imageUrl);
    setShowCropModal(true);
    
    // Reset file input
    e.target.value = '';
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const createImage = (url) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => resolve(image));
      image.addEventListener('error', (error) => reject(error));
      image.src = url;
    });
  };

  const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/jpeg', 0.95);
    });
  };

  const handleCropSave = async () => {
    if (!croppedAreaPixels || !imageToCrop) return;

    setIsUploadingAvatar(true);
    setShowCropModal(false);

    try {
      const croppedBlob = await getCroppedImg(imageToCrop, croppedAreaPixels);
      
      // Create file from blob
      const file = new File([croppedBlob], originalFileName || 'avatar.jpg', {
        type: 'image/jpeg',
      });

      const formData = new FormData();
      formData.append('avatar', file);
      formData.append('groupId', props.chat?.id);

      const { data } = await callAPI('/group/updateGroupAvatar', {}, 'POST', formData);
      
      if (data.status) {
        setGroupAvatar(data.avatar);
        setGroupAvatarPreview(BASE_URL + data.avatar);
        await $crud.notify({
          type: "success",
          message: isGerm ? "Gruppenbild erfolgreich aktualisiert" : "Group avatar updated successfully",
        });
      } else {
        await $crud.notify({
          type: "error",
          message: data.message || (isGerm ? "Fehler beim Hochladen des Bildes" : "Error uploading image"),
        });
      }
    } catch (error) {
      console.error('Error uploading avatar:', error);
      await $crud.notify({
        type: "error",
        message: isGerm ? "Fehler beim Hochladen des Bildes" : "Error uploading image",
      });
    } finally {
      setIsUploadingAvatar(false);
      if (imageToCrop) {
        URL.revokeObjectURL(imageToCrop);
      }
      setImageToCrop(null);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setCroppedAreaPixels(null);
    }
  };

  const handleCropCancel = () => {
    setShowCropModal(false);
    if (imageToCrop) {
      URL.revokeObjectURL(imageToCrop);
    }
    setImageToCrop(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const navigateUserProfile = (person) => {
    if (!person?.id) return;
    requestDirectMessage({
      id: person.id,
      fullName: person.fullName,
      firstName: person.firstName,
      lastName: person.lastName,
      avatar: person.avatar,
    });
  }

  const getInviteLink = async () => {
    const id = props.chat?.id;
    const { data } = await callAPI(
      `/invite-user/deeplink`,
      {
        inviteType: 'group',
        group: id,
        buildingList: props.project.id,
      },
      "POST"
    );
    if (data.status) {
      let splitToken = data?.deeplinkUrl?.split("/");
      let getToken = splitToken[splitToken?.length - 1];
      setDeepLink(`${window.location.origin}/register?token=${getToken}`);
    }
  };

  const getString = () => {
    if (isGerm) {
      return `Teilen Sie diesen Link, um ein Nicht-Mitglied von Kjuup zum Projekt ${props.project.name} und zur Chat Gruppe ${props.chat?.name} einzuladen. Der komplette Chatverlauf wird geteilt. Diesen Link können mehrere Personen nutzen.\n\n${deeplink}`
    }
    else {
      return `Share this link to invite a non-member of Kjuup to the project ${props.project.name} and the chat group ${props.chat?.name}. The entire chat history will be shared. This link can be used by multiple people.\n\n${deeplink}`
    }
  }

  const copyLink = async () => {
    const Url = getString()
    navigator.clipboard.writeText(Url).then(r => {
      $crud.notify({
        type: 'success',
        message: strings.link_copied
      })
    })
  }

  const [isEmailOn, setIsEmailOn] = useState(props.isEmailAllowed && userN?.emailVerified)

  const _onPreEmailNotification = async () => {
    let emailNotification = !isEmailOn
    setIsEmailOn(emailNotification)
    await callAPI(`/group/emailNotification`, {}, "PUT", {
      emailNotification,
      group: props.chat?.id
    });
  }

  const handleMuteToggle = () => {
    setShowMuteConfirm(true);
  };

  const confirmMuteUnmute = async () => {
    const newMuteState = !isMuted;
    setShowMuteConfirm(false);
    try {
      const { data } = await callAPI(
        "/group/muteUnmuteChat",
        {
          mute: newMuteState,
          group: props.chat?.id,
        },
        "PUT"
      );

      if (data.status) {
                setIsMuted(newMuteState);
        $crud.notify({
          type: "success",
          message: newMuteState
            ? strings.chat_muted_successfully
            : strings.chat_unmuted_successfully,
        });

        const updatedGroups = props.groups.map((g) => {
          if (g.id === props.chat?.id) {
            const updatedUsers = g.users.map((u) =>
              u.id === user?.id ? { ...u, isMute: newMuteState } : u
            );
            return { ...g, users: updatedUsers };
          }
          return g;
        });
        props.updateGroups(updatedGroups);
      } else {
        $crud.notify({
          type: "error",
          message: data.message || strings.something_went_wrong,
        });
      }
    } catch (error) {
      $crud.notify({
        type: "error",
        message: strings.something_went_wrong,
      });
    }
  };

  const cancelMuteUnmute = () => {
    setShowMuteConfirm(false);
  };

  const getAutomaticExportInfoText = () => {
    let text = strings.automatic_chat_export_info;
    if (!userN?.email) {
      text = `${text} ${strings.automatic_chat_export_no_email}`;
    } else if (!userN?.emailVerified) {
      text = `${text} ${strings.text_to_verifiy}`;
    }
    return text;
  };

  const toggleAutomaticExportInfo = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowExportInfo((open) => !open);
  };

  const handleAutomaticExportToggle = async () => {
    if (!userN?.emailVerified) {
      setShowExportInfo(true);
      return;
    }
    const newValue = !isAutomaticExportOn;
    setIsAutomaticExportOn(newValue);

    if (newValue && exportEmail) {
      // If enabling and email exists, save immediately without notification
      await saveAutomaticExportSettings(newValue, exportEmail, false);
    } else if (!newValue) {
      // If disabling, save immediately without notification
      await saveAutomaticExportSettings(newValue, exportEmail, false);
    }
  };

  const handleExportEmailChange = (e) => {
    const newEmail = e.target.value;
    setExportEmail(newEmail);
    // Show confirm button if email changed from original or if there's no original email saved
    if (newEmail !== originalExportEmail || !originalExportEmail) {
      setShowConfirmButton(true);
    } else {
      setShowConfirmButton(false);
    }
  };

  const handleConfirmEmail = async () => {
    if (!exportEmail || !exportEmail.includes('@')) {
      await $crud.notify({
        type: "error",
        message: isGerm ? "Bitte geben Sie eine gültige E-Mail-Adresse ein" : "Please enter a valid email address",
      });
      return;
    }
    await saveAutomaticExportSettings(isAutomaticExportOn, exportEmail);
  };

  const saveAutomaticExportSettings = async (enabled, email, showNotification = true) => {
    const id = props.chat?.id;
    try {
      const { data } = await callAPI(
        `/group/${id}/updateChatExportSetting`,
        {},
        "PUT",
        {
          isChatExport: enabled,
          exportEmail: email
        }
      );
      if (data.status) {
        if (showNotification) {
          await $crud.notify({
            type: "success",
            message: isGerm ? "Einstellungen gespeichert" : "Settings saved",
          });
        }
        // Update original email after successful save
        setOriginalExportEmail(email);
        setShowConfirmButton(false);
      } else {
        // Show the message from API (e.g., email confirmation required)
        // Don't hide the button if save failed - user needs to confirm email first
        await $crud.notify({
          type: "warning",
          message: data.message || (isGerm ? "Fehler beim Speichern" : "Error saving"),
        });
      }
    } catch (error) {
      await $crud.notify({
        type: "error",
        message: isGerm ? "Fehler beim Speichern" : "Error saving",
      });
    }
  };

  useEffect(() => {
    if (userN?.email && !exportEmail) {
      setExportEmail(userN.email);
      setOriginalExportEmail(userN.email);
    }
  }, [userN?.email]);

  useEffect(() => {
    // Pre-fill email if user has one
    if (userN?.email) {
      setChatHistoryEmail(userN.email);
    }
  }, [userN?.email]);

  useEffect(() => {
    // Apply border color directly to the input element after DOM updates
    const switchId = `custom-switch-automatic-export-${props.chat?.id}`;
    const applyStyles = () => {
      const inputElement = document.getElementById(switchId);
      if (inputElement) {
        const borderColor = props.isInternal ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color;
        inputElement.style.setProperty('border-color', borderColor, 'important');
        inputElement.style.setProperty('border-width', '1px', 'important');
        if (isAutomaticExportOn) {
          inputElement.style.setProperty('background-color', borderColor, 'important');
          inputElement.style.setProperty('border-color', borderColor, 'important');
        } else {
          inputElement.style.setProperty('background-color', '#ccc', 'important');
        }
      }
    };

    // Apply immediately and after a short delay to ensure DOM is ready
    applyStyles();
    const timeoutId = setTimeout(applyStyles, 100);
    return () => clearTimeout(timeoutId);
  }, [isAutomaticExportOn, props.isInternal, props.chat?.id, loaded]);

  useEffect(() => {
    // Remove inline styles from automatic export email section and ensure CSS is applied
    const removeInlineStyles = () => {
      const emailSection = document.querySelector('.automatic-export-email-section');
      if (emailSection) {
        // Remove inline padding and border styles to let CSS take over
        emailSection.style.removeProperty('padding');
        emailSection.style.removeProperty('padding-top');
        emailSection.style.removeProperty('padding-right');
        emailSection.style.removeProperty('padding-bottom');
        emailSection.style.removeProperty('padding-left');
        emailSection.style.removeProperty('border');
        // Ensure CSS class is applied
        if (!emailSection.classList.contains('automatic-export-email-section')) {
          emailSection.classList.add('automatic-export-email-section');
        }
      }
    };

    if (isAutomaticExportOn && !props.viewByOwner) {
      // Apply immediately and after delays to catch any dynamically added styles
      removeInlineStyles();
      const timeoutId1 = setTimeout(removeInlineStyles, 50);
      const timeoutId2 = setTimeout(removeInlineStyles, 200);
      return () => {
        clearTimeout(timeoutId1);
        clearTimeout(timeoutId2);
      };
    }
  }, [isAutomaticExportOn, props.chat?.id, props.viewByOwner]);

  const handleChatHistoryRequest = () => {
    setShowChatHistoryRequest(!showChatHistoryRequest);
  };

  const handleConfirmChatHistoryRequest = async () => {
    if (!chatHistoryEmail.trim() || isLoadingChatHistory) {
      return;
    }

    setIsLoadingChatHistory(true);
    try {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const { data } = await callAPI(
        `/group/${props.chat?.id}/exportFullChat`,
        {
          timezone: timeZone,
          lang: isGerm ? 'de' : 'en',
          viewByOwner: false,
          email: chatHistoryEmail
        },
        'GET'
      );

      if (data && data.status) {
        // Success - show success message or close form
        setShowChatHistoryRequest(false);
        await $crud.notify({
          type: "success",
          message: data.message || (isGerm ? "Chatverlauf-Anfrage erfolgreich gesendet" : "Chat history request sent successfully"),
        });
      } else {
        await $crud.notify({
          type: "error",
          message: (data && data.message) || (isGerm ? "Chatverlauf-Anfrage konnte nicht gesendet werden" : "Failed to send chat history request"),
        });
      }
    } catch (error) {
      console.log('Error requesting chat history:', error);
      await $crud.notify({
        type: "error",
        message: isGerm ? "Fehler beim Anfordern des Chatverlaufs" : "Error requesting chat history",
      });
    } finally {
      setIsLoadingChatHistory(false);
    }
  };

  const closeMemberMenu = useCallback(() => setMemberMenu(null), []);

  // ---------- Page model (mobile GroupInfoPro) ----------
  // Built in a function of its own: its many branches would otherwise overflow the
  // hooks linter's path count for this long component (false "called conditionally").
  const buildPageModel = () => {
    const isRoomChat = !!props.chat?.defaultChatGroup;
    const fullView = !props.viewByOwner && !isMember && !props.chat?.isLeave;
    const emailDisabled = !userN?.emailNotification || !userN?.emailVerified;
    const myId = user?.id != null ? String(user.id) : null;
    const myName = myFullName(user);
    const formatPosition = positionFormatter(strings);
    const currentMember = roomPeople?.currentMember || null;
    const myCompany = String(currentMember?.companyName || "").trim().toLowerCase();
    const personOf = (id) => {
      const key = String(id);
      if (currentMember && String(currentMember.id) === key) return currentMember;
      return roomPeople?.byId?.get(key) || null;
    };
    const visibleUsers = loaded && Array.isArray(users)
      ? _.sortBy(users.filter((u) => u && !u.isLeave), [us => (us?.lastName || us?.lastname || "").toLowerCase()])
      : [];
    const memberRows = visibleUsers.map((u) => {
      const isSelf = myId != null && String(u?.id) === myId;
      // A Teams person of a Kjuup + Teams group without a Kjuup login: no profile, no DM, no admin.
      const guest = isTeamsGuest(u);
      // Switched the Kjuup chats off: still a member, but not reachable here, so they
      // must not be made admin. An existing admin can still be demoted.
      const chatsHidden = !isSelf && u?.chatsEnabled === false;
      const showAdminToggle = canManageAdmins && !isSelf && !guest && (!chatsHidden || u.isAdmin);
      const canRemoveThisMember =
        !u?.isAdmin &&
        !props?.chat?.defaultChatGroup &&
        isAdmin &&
        !isSelf &&
        !props.project.viewByOwner &&
        !props.fromActivity &&
        !props.project.isDone;
      const person = personOf(u.id);
      const company = String(person?.companyName || "").trim();
      // External = another company than yours in this room; nobody is tagged while yours is unknown.
      const external = !isSelf && !!myCompany && !!company && company.toLowerCase() !== myCompany;
      return {
        key: String(u.id),
        user: u,
        // Design: your own row shows your full name (no "Me").
        name: isSelf ? (myName || u?.fullName || strings.me) : u?.fullName,
        src: avatarSrc(u?.avatar),
        adminLabel: u.isAdmin && !isRoomChat ? strings.admin : null,
        roleLine: roleLineOf(person, formatPosition),
        hidden: chatsHidden,
        hiddenLabel: chatsHidden ? (strings.chats_hidden_label || (isGerm ? "Chats ausgeblendet" : "Chats hidden")) : null,
        presence: !isSelf && !chatsHidden && !guest
          ? { online: !!u.isOnline, label: u.isOnline ? (strings.is_active || "Active") : lastOnlineText(u.lastOnlineAt, strings, language) }
          : null,
        externalLabel: external && !guest ? infoText(strings, isGerm, "chat_info_external", "Extern", "External") : null,
        teamsLabel: guest ? infoText(strings, isGerm, "combined_guest_tag", "Teams", "Teams") : null,
        canMessage: !isSelf && !guest,
        adminAction: showAdminToggle,
        removeAction: canRemoveThisMember,
        menu: !isSelf && (showAdminToggle || canRemoveThisMember),
      };
    });

    const openMember = (m, e) => {
      if (m.menu) setMemberMenu({ member: m, anchorEl: e && e.currentTarget ? e.currentTarget : null });
      else if (m.canMessage) navigateUserProfile(m.user);
    };
    const menuMember = memberMenu ? memberMenu.member : null;
    const memberMenuItems = menuMember
      ? [
        menuMember.canMessage
          ? {
            key: "chat",
            icon: "chat",
            label: infoText(strings, isGerm, "chat_info_send_message", "Nachricht senden", "Send message"),
            onClick: () => navigateUserProfile(menuMember.user),
          }
          : null,
        menuMember.adminAction
          ? {
            key: "admin",
            icon: "admin_panel_settings",
            label: menuMember.user.isAdmin
              ? (strings.remove_group_admin_rights || (isGerm ? "Adminrechte entziehen" : "Remove admin rights"))
              : (strings.assign_group_admin_rights || (isGerm ? "Adminrechte zuweisen" : "Assign admin rights")),
            onClick: () => toggleGroupAdmin(menuMember.user),
          }
          : null,
        menuMember.removeAction
          ? {
            key: "remove",
            icon: "person_remove",
            label: strings.remove_user_l || (isGerm ? "Entfernen" : "Remove"),
            danger: true,
            onClick: () => removeMember(menuMember.user),
          }
          : null,
      ].filter(Boolean)
      : [];

    const roomName = stripMarkdown(props.project?.name || "") || strings.all_members || (isGerm ? "Alle" : "All");
    const heroName = isRoomChat ? roomName : stripMarkdown(groupName || "");
    const kindLabel = isRoomChat
      ? infoText(strings, isGerm, "chat_info_kind_room", "Projekt", "Project")
      : infoText(strings, isGerm, "chat_info_kind_group", "Gruppe", "Group");
    const countLabel = memberRows.length === 1
      ? infoText(strings, isGerm, "chat_info_member_one", "1 Mitglied", "1 member")
      : fillN(infoText(strings, isGerm, "chat_info_members_count", "{n} Mitglieder", "{n} members"), memberRows.length);
    const heroSub = loaded ? `${kindLabel} · ${countLabel}` : kindLabel;
    const canEditName = !isRoomChat && isAdmin && !props.fromActivity && !props.project.isDone;
    const membersLabel = infoText(strings, isGerm, "chat_info_members", "Mitglieder", "Members");
    const canAddMember =
      !isRoomChat &&
      !props.viewByOwner &&
      !props.project?.viewByOwner &&
      !props.project?.isDone &&
      !props.projectDetails?.isDone &&
      !props.fromActivity &&
      !isMember &&
      !props.chat?.isLeave;
    const canLeave = !props.chat?.defaultChatGroup && !props.chat?.isLeave && !props.projectDetails?.isDone && !props.viewByOwner && !isMember && !props.fromActivity;
    const pageTitle = isRoomChat
      ? infoText(strings, isGerm, "chat_info_title_room", "Projekt-Chat-Info", "Project chat info")
      : infoText(strings, isGerm, "chat_info_title_group", "Gruppen-Info", "Group info");
    const awayMembers = unavailableMembers.filter((u) => u.userId !== user?.id);
    const descriptionLong = !!description && description.length > DESCRIPTION_PREVIEW;
    const descriptionEditable = isAdmin && !showFullDescription && !props.fromActivity && !props.project.isDone;
    const showInvite = !props.isInternal && !props.viewByOwner && !isMember && !props.chat?.isLeave;
    const inviteText = deeplink
      ? getString().replace(deeplink, "").trim()
      : (isGerm
        ? `Teilen Sie diesen Link, um ein Nicht-Mitglied von Kjuup zum Projekt ${props.project?.name || ''} und zur Chat Gruppe ${props.chat?.name || ''} einzuladen. Der komplette Chatverlauf wird geteilt. Diesen Link können mehrere Personen nutzen.`
        : `Share this link to invite a non-member of Kjuup to the project ${props.project?.name || ''} and the chat group ${props.chat?.name || ''}. The entire chat history will be shared. This link can be used by multiple people.`);
    const linkExpireText = String(strings.link_expire || "")
      .replace('72 hours', '10 days')
      .replace('72 ore', '10 giorni')
      .replace('72 Stunden', '10 Tage')
      .replace('72 heures', '10 jours')
      .replace('72 horas', '10 días')
      .replace('72 uur', '10 dagen')
      .replace('72 timer', '10 dager')
      .replace('72 timmar', '10 dagar')
      .replace('72 tuntia', '10 päivää')
      .replace('72 godziny', '10 dni')
      .replace('72 saat', '10 gün')
      .replace('72 ώρες', '10 ημέρες')
      .replace('72 hodin', '10 dní')
      .replace('72 óra', '10 nap')
      .replace('72 de ore', '10 zile')
      .replace('72 sata', '10 dana')
      .replace('72 ur', '10 dni')
      .replace('72小时', '10天')
      .replace('72 घंटे', '10 दिन')
      .replace('72 ساعة', '10 أيام')
      .replace('72時間', '10日')
      .replace('72시간', '10일')
      .replace('72 giờ', '10 ngày')
      .replace('72 jam', '10 hari')
      .replace('72 மणி', '10 நாட்கள்')
      .replace('72 గంటలు', '10 రోజులు')
      .replace('72 часа', '10 дней')
      .replace('72 часа', '10 дни');

    const tiles = [
      typeof props.setSearch === "function" && !props.viewByOwner
        ? { key: "search", icon: "search", label: strings.search || (isGerm ? "Suche" : "Search"), onClick: viewSearch }
        : null,
      fullView
        ? {
          key: "mute",
          // Short tile words, as on mobile ("Stummschaltung aufheben" does not fit a tile).
          icon: isMuted ? "notifications" : "notifications_off",
          label: isMuted
            ? infoText(strings, isGerm, "chat_info_unmute", "Ton an", "Unmute")
            : infoText(strings, isGerm, "chat_info_mute", "Stumm", "Mute"),
          ariaLabel: isMuted ? strings.unmute : strings.mute,
          onClick: handleMuteToggle,
        }
        : null,
      props.viewMediaDoc
        ? { key: "media", icon: "perm_media", label: infoText(strings, isGerm, "chat_info_media", "Dateien", "Files"), onClick: props.viewMediaDoc }
        : null,
      { key: "export", icon: "picture_as_pdf", label: infoText(strings, isGerm, "chat_info_export", "Export", "Export"), onClick: goExport },
    ];
    return {
      isRoomChat,
      fullView,
      emailDisabled,
      memberRows,
      openMember,
      memberMenuItems,
      heroName,
      heroSub,
      canEditName,
      membersLabel,
      canAddMember,
      canLeave,
      pageTitle,
      awayMembers,
      descriptionLong,
      descriptionEditable,
      showInvite,
      inviteText,
      linkExpireText,
      tiles,
    };
  };
  const {
    isRoomChat,
    fullView,
    emailDisabled,
    memberRows,
    openMember,
    memberMenuItems,
    heroName,
    heroSub,
    canEditName,
    membersLabel,
    canAddMember,
    canLeave,
    pageTitle,
    awayMembers,
    descriptionLong,
    descriptionEditable,
    showInvite,
    inviteText,
    linkExpireText,
    tiles,
  } = buildPageModel();

  return (
    <React.Fragment>
      {!addMember && !addChatUserAction.status && !addUserAction.status && (
        <div className={`chat_user_info group_chat_user_info border-radius-0 m-0 p-0 user-info kjp-info-shell${props.isInternal ? ` chat_user_info-internal user-info--internal${infoToneClass(true)}` : ""}`}>
          {viewLoader && (
            <div className="website_loader">
              <div className="loader" />
            </div>
          )}
          <div className="kjp-info-head">
            <button
              type="button"
              className="kj-btn kj-btn--icon kj-btn--neutral kjp-info-head__back"
              onClick={props.handleClose}
              aria-label={strings.back || (isGerm ? "Zurück" : "Back")}
              title={strings.back || (isGerm ? "Zurück" : "Back")}
            >
              <span className="material-symbols-outlined">keyboard_arrow_left</span>
            </button>
            <div className="kjp-info-head__title">{pageTitle}</div>
          </div>
          <div className="kjp-info-shell__body">
            <CustomScrollbars
              autoHide
              autoHideTimeout={200}
              autoHideDuration={200}
              className="bottom-bar"
            >
              <div className={`kjp-info${infoToneClass(props.isInternal)}`}>
                {isEditingName ? (
                  <div className="kjp-info-hero kjp-info-hero--editing">
                    <div className="kjp-info-hero__avatar">
                      <InfoAvatar kind={isRoomChat ? "room" : "group"} name={heroName} src={isRoomChat ? avatarSrc(props.chat?.image) : ""} size={80} />
                    </div>
                    <InfoEditBox
                      value={editedName}
                      onChange={handleInputChangeNAme}
                      placeholder={!isGerm ? "Add group name..." : "Gruppennamen hinzufügen..."}
                      maxLength={30}
                      note={`${30 - (editedName || "").length} ${strings.characters_remaining}`}
                      onSave={handleSaveGroupname}
                      onCancel={handleCancel}
                      saveLabel={strings.save || (isGerm ? "Speichern" : "Save")}
                      cancelLabel={strings.cancel}
                    />
                  </div>
                ) : (
                  <InfoHero
                    kind={isRoomChat ? "room" : "group"}
                    name={heroName}
                    src={isRoomChat ? avatarSrc(props.chat?.image) : ""}
                    sub={heroSub}
                    trailing={canEditName ? <InfoEditPencil onClick={handleEditClickName} label={strings.edit || (isGerm ? "Bearbeiten" : "Edit")} /> : null}
                  />
                )}
                {(isAdmin || description) ? (
                  <div className="kjp-info-section">
                    <InfoCaption title={infoText(strings, isGerm, "chat_info_description", "Beschreibung", "Description")} />
                    <div className="kjp-info-card kjp-info-desc">
                      {isAdmin && isEditing ? (
                        <InfoEditBox
                          value={editedDescription || ""}
                          onChange={handleInputChange}
                          placeholder={!isGerm ? "Add description..." : "Beschreibung hinzufügen..."}
                          multiline
                          inputRef={textareaRef}
                          onSave={handleSave}
                          onCancel={handleCancel}
                          saveLabel={strings.save || (isGerm ? "Speichern" : "Save")}
                          cancelLabel={strings.cancel}
                        />
                      ) : (
                        <div className="kjp-info-desc__row">
                          <div className={`kjp-info-desc__text${description ? "" : " is-empty"}`}>
                            {displayDescription()}
                            {descriptionLong ? (
                              <span
                                className="kjp-info-desc__toggle"
                                role="button"
                                tabIndex={0}
                                onClick={toggleDescription}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    toggleDescription();
                                  }
                                }}
                              >
                                {showFullDescription ? ` ${strings.see_less}` : ` ${strings.see_more}`}
                              </span>
                            ) : null}
                          </div>
                          {descriptionEditable ? (
                            <InfoEditPencil onClick={handleEditClick} label={strings.edit || (isGerm ? "Bearbeiten" : "Edit")} />
                          ) : null}
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
                <InfoAwayBanner
                  members={awayMembers}
                  showName
                  contactLabel={strings.unavailability_contact_urgent}
                  onContactReplacement={openReplacementChat}
                />
                <InfoTiles tiles={tiles} />
                <InfoCard>
                  {props.viewMediaDoc ? (
                    <InfoRow
                      key="media"
                      icon="photo"
                      label={strings.media_link_docs}
                      value={mediaCount != null ? String(mediaCount) : null}
                      onClick={props.viewMediaDoc}
                    />
                  ) : null}
                  {!props.viewByOwner ? (
                    <InfoToggleRow
                      key="email"
                      icon="mail"
                      label={strings.email_on_grp}
                      checked={emailDisabled ? false : isEmailOn}
                      disabled={emailDisabled}
                      dim={emailDisabled}
                      onToggle={() => { _onPreEmailNotification() }}
                      id={`custom-switchx-setting-user-group-chat-${props.chat?.id}`}
                      isInternal={props.isInternal}
                      infoOpen={showEmailInfo}
                      onInfo={() => setShowEmailInfo((open) => !open)}
                      onRowClick={!userN?.emailVerified ? () => setShowEmailInfo((open) => !open) : undefined}
                      note={
                        <>
                          {strings.email_groups}
                          {!userN?.emailVerified ? ` ${strings.text_to_verifiy}` : ""}
                        </>
                      }
                    />
                  ) : null}
                </InfoCard>
                <InfoCaption
                  title={loaded ? `${membersLabel} · ${memberRows.length}` : membersLabel}
                  action={canAddMember ? infoText(strings, isGerm, "chat_info_add", "Hinzufügen", "Add") : null}
                  actionIcon="person_add"
                  onAction={handleAddUser}
                />
                <div className="kjp-info-card">
                  {!loaded ? (
                    [0, 1, 2].map((i) => (
                      <div key={i} className="kjp-info-skel" aria-hidden="true">
                        <div className="kjp-info-skel__circle" />
                        <div className="kjp-info-skel__lines">
                          <div className="kjp-info-skel__bar" />
                          <div className="kjp-info-skel__bar" />
                        </div>
                      </div>
                    ))
                  ) : memberRows.length ? (
                    memberRows.map((m) => (
                      <div key={m.key} className="kjp-info-card__item">
                        <InfoMemberRow
                          m={m}
                          active={!!(memberMenu && memberMenu.member.key === m.key)}
                          onClick={m.menu || m.canMessage ? (e) => openMember(m, e) : undefined}
                        />
                      </div>
                    ))
                  ) : (
                    <div className="kjp-info-empty">
                      {infoText(strings, isGerm, "chat_info_no_members", "Keine Mitglieder gefunden", "No members found")}
                    </div>
                  )}
                </div>
                {showInvite ? (
                  <div className="kjp-info-card kjp-info-invite">
                    <p className="kjp-info-invite__text">{inviteText}</p>
                    <div className="kjp-info-invite__foot">
                      <button
                        type="button"
                        className="kj-btn kj-btn--outline kj-btn--sm"
                        onClick={deeplink ? copyLink : undefined}
                        disabled={!deeplink}
                      >
                        <span className="material-symbols-outlined">content_copy</span>
                        {strings.copy_link}
                      </button>
                      <div className="kjp-info-invite__expire">{linkExpireText}</div>
                    </div>
                  </div>
                ) : null}
                <InfoExportCard
                  ref={exportCardRef}
                  isInternal={props.isInternal}
                  autoExport={fullView ? {
                    enabled: isAutomaticExportOn,
                    onToggle: handleAutomaticExportToggle,
                    email: exportEmail,
                    onChangeEmail: handleExportEmailChange,
                    savedEmail: originalExportEmail,
                    emailVerified: !!userN?.emailVerified,
                    onUpdate: handleConfirmEmail,
                    infoOpen: showExportInfo,
                    onInfo: toggleAutomaticExportInfo,
                    onRowClick: !userN?.emailVerified ? () => setShowExportInfo((open) => !open) : undefined,
                    switchId: `custom-switch-automatic-export-${props.chat?.id}`,
                    note: (
                      <>
                        {getAutomaticExportInfoText()}
                        {!userN?.emailVerified && (
                          <>
                            {" "}
                            <a
                              href="#profile-setting"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                history.push("/profile-setting");
                              }}
                            >
                              {strings.email_go_to_settings}
                            </a>
                          </>
                        )}
                      </>
                    ),
                  } : null}
                  pdf={{ chat: props.chat, openSignal: exportSignal }}
                  history={{
                    open: showChatHistoryRequest,
                    onToggle: handleChatHistoryRequest,
                    email: chatHistoryEmail,
                    onChangeEmail: (e) => setChatHistoryEmail(e.target.value),
                    onConfirm: handleConfirmChatHistoryRequest,
                    loading: isLoadingChatHistory,
                    placeholder: userN?.email ? strings.email : strings.enter_your_email_add,
                  }}
                />
                {canLeave ? (
                  <InfoLeaveButton
                    icon="logout"
                    tone="err"
                    label={infoText(strings, isGerm, "chat_info_leave_group", "Chat Gruppe verlassen", "Leave chat group")}
                    onClick={toggleBlockUser}
                  />
                ) : null}
              </div>
            </CustomScrollbars>
          </div>
          {memberMenu ? (
            <InfoPopoverMenu
              anchorEl={memberMenu.anchorEl}
              title={memberMenu.member.name}
              items={memberMenuItems}
              onClose={closeMemberMenu}
              isInternal={props.isInternal}
            />
          ) : null}
        </div>
      )}
      {
        (addUserAction.status && !addChatUserAction.status) ? (
          <div
            className={`w-300 p-0 m-0 user-info__add-panel user-info__add-panel--column${props.project.isInternal ? " user-info__add-panel--internal" : ""}`}
          >
            <AddProjectUser
              project_id={props.project.id}
              handleEditClose={() => {
                setAddUserAction({ status: false, id: null });
              }}
              addAsMember={true}
              setAllUsers={setAllUsers}
              allUsers={allUsers}
              setAddChatUserAction={setAddChatUserAction}
              setAddUserAction={setAddUserAction}
              isInternal={props.isInternal}
              cID={props.cID}
              groupId={props.chat?.id}
              Mems={props.Mems}
            />
          </div>
        ) : <></>
      }
      {
        addChatUserAction.status ?
          <div
            className={`w-300 p-0 m-0 user-info__add-panel${props.project.isInternal ? " user-info__add-panel--internal" : ""}`}
          >
            {addChatUserAction.groupMode ? (
              <AddProjectChatUser
                from={'group'}
                project={props.project}
                addAsMember={true}
                users={props.users ? props.users : []}
                project_id={addChatUserAction.id}
                handleEditClose={() => {
                  setAddChatUserAction({ status: false, id: null });
                }}
                setAllUsers={setAllUsers}
                allUsers={allUsers}
                isInternal={addChatUserAction.isInternal}
                cID={addChatUserAction.cID}
                groupId={props.chat?.id}
                Mems={props.Mems}
              />
            ) : (
              <AddProjectChatUser
                users={props.users ? props.users : []}
                project_id={addChatUserAction.id}
                handleEditClose={() => {
                  setAddChatUserAction({ status: false, id: null });
                }}
                setAllUsers={setAllUsers}
                allUsers={allUsers}
                isInternal={addChatUserAction.isInternal}
                cID={addChatUserAction.cID}
                Mems={props.Mems}
              />
            )}
          </div>
          :
          <></>
      }
      
      {/* Leave Chat Confirmation Dialog */}
      <LeaveConfirmDialog
        open={showLeaveConfirmDialog}
        onClose={() => setShowLeaveConfirmDialog(false)}
        onConfirm={handleLeaveConfirm}
        title={infoText(strings, isGerm, "chat_info_leave_confirm", "Willst du die Chat-Gruppe wirklich verlassen?", "Do you really want to leave the chat group?")}
        isInternal={props.isInternal === true || props.project?.isInternal === true}
        confirmText="Ok"
        cancelText={strings.cancel}
      />

      {/* Mute/Unmute Confirmation Modal */}
      <Modal
        show={showMuteConfirm}
        onHide={cancelMuteUnmute}
        animation={false}
        centered
      >
        <Modal.Body className="modal-body-relative">
          <p>
            {!isMuted
              ? strings.mute_chat_confirm
              : strings.unmute_chat_confirm
            }
          </p>
        </Modal.Body>
        <Modal.Footer className="user-info__modal-footer">
          <button
            onClick={cancelMuteUnmute}
            className={`kj-btn kj-btn--outline kj-btn--on-surface${props.isInternal ? ' kj-btn--internal' : ''}`}
          >
            {strings.cancel}
          </button>
          <button
            onClick={confirmMuteUnmute}
            className={`kj-btn kj-btn--primary${props.isInternal ? ' kj-btn--internal' : ''}`}
          >
            {strings.ok}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Image Crop Modal */}
      <Modal
        show={showCropModal}
        onHide={handleCropCancel}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton className="user-info__crop-header">
          <Modal.Title className="user-info__crop-title">
            {isGerm ? "Bild zuschneiden" : "Crop Image"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="user-info__crop-body">
          <div className="user-info__crop-area">
            {imageToCrop && (
              <Cropper
                image={imageToCrop}
                crop={crop}
                zoom={zoom}
                aspect={1}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            )}
          </div>
          <div className="user-info__crop-zoom">
            <label className="user-info__crop-zoom-label">
              {isGerm ? "Zoom" : "Zoom"}
            </label>
            <input
              type="range"
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              onChange={(e) => setZoom(e.target.value)}
              className="user-info__crop-zoom-input"
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="user-info__crop-footer">
          <button
            onClick={handleCropCancel}
            className="kj-btn kj-btn--secondary"
          >
            {strings.cancel}
          </button>
          <button
            onClick={handleCropSave}
            className={`kj-btn kj-btn--primary${props.isInternal ? ' kj-btn--internal' : ''}`}
          >
            {isGerm ? "Speichern" : "Save"}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment >
  );
}

const mapStateToProps = (state) => {
  const { openChats, groups } = state;
  return {
    groups: groups,
    openChats: openChats,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    updateOpenChatsList: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserInfo));